import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PandaPickLogo from "../../assets/pandalogo.png";

const Nav = ({ onLogout })  => {
    const auth = localStorage.getItem('user');
    const empauth = localStorage.getItem('empuser');
    const navigate = useNavigate();
   const logout = () => {
        onLogout();
         navigate('/login');
    };




    return (
        <header>

        <div className='container'>

        <div className='nav-ul'>
            
           <Link to="/"><img  src={PandaPickLogo}  alt="PandaPick" className='logo'/></Link>
            {
                auth ?

                    <ul>
                        <li><Link to="/productlist">ALL Products</Link></li>
                        <li><Link to="/add">Add Product</Link></li>
                        <li><Link to="/create-project">Create Project</Link></li>
                        <li><Link onClick={logout} to="/login">Logout</Link></li>
                    </ul>
                    :
                    <ul className='nav-ul'>
                         {empauth ?
                         <>
                         <li><Link to="/time-tracker">Time Tracker</Link></li>
                        <li><Link to="/my-record">My Record</Link></li>
                        </>
                        :
                       
                          <>
                       {/* <li><Link to="/mark-attendance">Mark Attendance</Link></li>*/}
                        <li><Link to="/login">Company Portal</Link></li>
                        </>
                         }
                    </ul>

            }
            </div>

        </div>

        </header>
    )
}

export default Nav;